// extracted by mini-css-extract-plugin
export var chip = "_au-0";
export var filterDropdown = "_au-5";
export var filterItem = "_au-6";
export var icon = "_au-1";
export var removeButton = "_au-3";
export var removeIcon = "_au-4";
export var separator = "_au-2";